export default "__VITE_ASSET__BpohSr1I__"